// Un lanzamiento cambió desde otro lado (el chat): la pantalla abierta de ese lanzamiento lo vuelve a leer.
// Antes la tarjeta "Agregar al lanzamiento" guardaba el producto y la pantalla seguía en "0 productos" hasta
// recargar (prueba en vivo del 5/10, ADR-2026-10-05-ficha-ml-prueba-en-vivo-front).
export const EVENTO_CAMBIO_DE_LANZAMIENTO = 'atlas:lanzamiento-cambio';

export function avisarCambioDeLanzamiento(lanzamientoId: string): void {
  if (typeof window === 'undefined') return;
  window.dispatchEvent(new CustomEvent(EVENTO_CAMBIO_DE_LANZAMIENTO, { detail: { id: lanzamientoId } }));
}

/** Escucha los cambios de UN lanzamiento. Devuelve cómo dejar de escuchar. */
export function escucharCambiosDeLanzamiento(lanzamientoId: string, alCambiar: () => void): () => void {
  if (typeof window === 'undefined') return () => {};
  const oir = (e: Event) => {
    if ((e as CustomEvent<{ id?: string }>).detail?.id === lanzamientoId) alCambiar();
  };
  window.addEventListener(EVENTO_CAMBIO_DE_LANZAMIENTO, oir);
  return () => window.removeEventListener(EVENTO_CAMBIO_DE_LANZAMIENTO, oir);
}
